import React from 'react';
import CapitalCitiesGame from './components/CapitalCitiesGame';

function App() {
  return (
    <div className="App">
      <CapitalCitiesGame />
    </div>
  );
}

export default App;